import React from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    BillingDetailsContainer,
    BillingDetailsDataContainer,
    OrderPaymentContainer,
    BillingDetailsFont,
} from './BillingDetails.styled';
import {
    convertToMMddYYYYForRVM,
    notesTimeFormatter,
    getDisplayDate,
} from 'src/utils/dateUtils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const BillingDetails = ({ billingDetails, toggleCard, paddingValue }) => {
    const winWidth = window.innerWidth;
    const { t } = useTranslation();

    const billingDetailsData = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const patient_Details = useSelector(
        (state) => state.loginReducer.patient_Details
    );

    const billingData = [
        {
            hrefId: billingDetailsData?.procedureDetail?.HRefId,
            physician: billingDetailsData?.orderSummaryDetail?.physicianName,
            implantDate: billingDetailsData?.procedureDetail?.implantDate,
            patientName: billingDetailsData?.procedureDetail?.patientName,
        },
    ];
    // const BillingDetailsPresent = Object.values(billingData[0]).every(
    //     (value) => value === undefined
    // );

    return (
        <>
            {/* {!BillingDetailsPresent&& */}
            {/* ( */}
            <CollapsableCard
                id="orders-billingDetails-billingDetails-details"
                title={t('orders.orderDetails.billingSummary.billingdeatil')}
                onClick={() => toggleCard('billingDetails', !billingDetails)}
                isExpanded={billingDetails}
                padding={paddingValue ? paddingValue : '0.8rem'}
                // CollapsableCardIconWidthHeight={'12px'}
            >
                {billingData?.map((value) => {
                    return (
                        <BillingDetailsContainer key={value?.hrefId}>
                            {(value?.hrefId || value?.physician) && (
                                <BillingDetailsDataContainer
                                // marginLeft={orderType === 'ZOR'}
                                >   {value?.hrefId && 
                                    <OrderPaymentContainer
                                        margin={'10px 0 10px 0'}
                                        display={
                                            value?.hrefId !== undefined ||
                                            value?.hrefId !== ''
                                                ? ''
                                                : true
                                        }
                                    >
                                        {value?.hrefId ? (
                                            <>
                                                <BillingDetailsFont
                                                    fontFamily="AvenirNextWorld Demi"
                                                    fontSize="14px"
                                                    margin={'0 0 5px 0'}
                                                >
                                                    {t('orders.orderDetails.billingSummary.hosppatientref')}
                                                </BillingDetailsFont>
                                                <BillingDetailsFont>
                                                    {value.hrefId}
                                                </BillingDetailsFont>
                                            </>
                                        ) : null}
                                    </OrderPaymentContainer>
                                    }
                                    {value?.physician && 
                                    <OrderPaymentContainer
                                        margin={'10px 0 10px 0'}
                                        display={
                                            value?.physician !== undefined ||
                                            value?.physician !== ''
                                                ? ''
                                                : true
                                        }
                                    >
                                        {value?.physician ? (
                                            <>
                                                <BillingDetailsFont
                                                    fontFamily="AvenirNextWorld Demi"
                                                    fontSize="14px"
                                                    margin={'0 0 5px 0'}
                                                >
                                                    {t('orders.searchOrdersPanel.physician')}
                                                </BillingDetailsFont>
                                                <BillingDetailsFont>
                                                    {value.physician}
                                                </BillingDetailsFont>
                                            </>
                                        ) : null}
                                    </OrderPaymentContainer>
                                    }
                                </BillingDetailsDataContainer>
                            )}
                            {(value?.patientName || value?.implantDate) && (
                                <BillingDetailsDataContainer
                                // marginLeft={orderType === 'ZOR'}
                                >
                                    {value?.patientName &&
                                    <OrderPaymentContainer
                                        margin={'20px 0 10px 0'}
                                    >
                                        {value?.patientName ? (
                                            <>
                                                <BillingDetailsFont
                                                    fontFamily="AvenirNextWorld Demi"
                                                    fontSize="14px"
                                                    margin={'0 0 5px 0'}
                                                >
                                                    {t('common.patientNameText')}
                                                </BillingDetailsFont>
                                                <BillingDetailsFont>
                                                    {value.patientName}
                                                </BillingDetailsFont>
                                            </>
                                        ) : null}
                                    </OrderPaymentContainer>
                                    }
                                    {value?.implantDate &&
                                    <OrderPaymentContainer
                                        margin={'20px 0 10px 0'}
                                    >
                                        {value?.implantDate ? (
                                            <>
                                                <BillingDetailsFont
                                                    fontFamily="AvenirNextWorld Demi"
                                                    fontSize="14px"
                                                    margin={'0 0 5px 0'}
                                                >
                                                    {t('consignmentBilling.account.implantDate')}
                                                </BillingDetailsFont>
                                                <BillingDetailsFont>
                                                    {getDisplayDate(
                                                        value.implantDate
                                                    )}
                                                </BillingDetailsFont>
                                            </>
                                        ) : null}
                                    </OrderPaymentContainer>
                                    }
                                </BillingDetailsDataContainer>
                            )}
                        </BillingDetailsContainer>
                    );
                })}
            </CollapsableCard>
            {/* )} */}
        </>
    );
};

export default BillingDetails;
